import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { novos_renovados_serie_rede } from "../../services/api";
import './tabelas_matricula.css';

const Alunos_novos_renovados_serie_rede = (props) => {
    const [dataTotal, setDataTotal] = useState([]);

    const fetchData = async () => {
        try {
            const response = await novos_renovados_serie_rede(props.di, props.df);
            setDataTotal(response || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => { fetchData(); }, [props.di, props.df]);

    const convertSegmento = (seg) => {
        const labels = {
            '0-1': 'Mat 1', '0-2': 'Mat 2', '0-3': 'Pré 1', '0-4': 'Pré 2',
            '1-1': '1º Fund I', '1-2': '2º Fund I', '1-3': '3º Fund I', '1-4': '4º Fund I', '1-5': '5º Fund I',
            '1-6': '6º Fund II', '1-7': '7º Fund II', '1-8': '8º Fund II', '1-9': '9º Fund II',
            '2-1': '1ª Médio', '2-2': '2ª Médio', '2-3': '3ª Médio'
        };
        return labels[seg] || seg;
    };

    const getVarClass = (value) => {
        if (value > 0) return "bg-green";
        if (value < 0) return "bg-red";
        return "";
    };

    let total = { n27: 0, r27: 0, t27: 0, n26: 0, r26: 0, t26: 0 };

    const processedData = dataTotal.map(item => {
        const n27 = parseInt(item.n2027) || 0; const r27 = parseInt(item.r2027) || 0; const t27 = parseInt(item.t2027) || 0;
        const n26 = parseInt(item.n2026) || 0; const r26 = parseInt(item.r2026) || 0; const t26 = parseInt(item.t2026) || 0;

        total.n27 += n27; total.r27 += r27; total.t27 += t27;
        total.n26 += n26; total.r26 += r26; total.t26 += t26;

        return {
            seg: convertSegmento(item.serie),
            n27, r27, t27, n26, r26, t26,
            ganhoN: n26 > 0 ? ((n27 / n26) * 100) - 100 : 0,
            ganhoR: r26 > 0 ? ((r27 / r26) * 100) - 100 : 0,
            ganhoT: t26 > 0 ? ((t27 / t26) * 100) - 100 : 0
        };
    });

    const getColorClass = (val) => val > 0 ? "text-positivo" : val < 0 ? "text-negativo" : "";

    return (
        <div className="mt-3">
            <h4 className="mb-3 fw-light text-secondary">Matrículas por Série da Rede</h4>
            <div className="table-responsive shadow-sm rounded border">
                <Table hover bordered className="text-center align-middle bg-white m-0 tabela-matriculas">
                    <thead className="table-dark">
                        <tr>
                            <th className="text-start ps-3">SEGMENTO</th>
                            <th>N 27</th><th>R 27</th><th>T 27</th>
                            <th>N 26</th><th>R 26</th><th>T 26</th>
                            <th>Ganho N%</th><th>Ganho R%</th><th>Ganho T%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {processedData.map((row, idx) => (
                            <tr key={idx}>
                                <td className="text-start fw-bold bg-light ps-3">{row.seg}</td>
                                <td className="text-primary">{row.n27}</td><td className="text-primary">{row.r27}</td><td className="fw-bold text-primary">{row.t27}</td>
                                <td className="text-danger">{row.n26}</td><td className="text-danger">{row.r26}</td><td className="fw-bold text-danger">{row.t26}</td>
                                <td className={getVarClass(row.ganhoN)}>{row.ganhoN.toFixed(2)}%</td>
                                <td className={getVarClass(row.ganhoR)}>{row.ganhoR.toFixed(2)}%</td>
                                <td className={getVarClass(row.ganhoT)}>{row.ganhoT.toFixed(2)}%</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="fw-bolder border-top border-dark bg-light">
                        <tr>
                            <td className="text-start ps-3">TOTAL</td>
                            <td className="text-primary">{total.n27}</td><td className="text-primary">{total.r27}</td><td className="fw-bold text-primary">{total.t27}</td>
                            <td className="text-danger">{total.n26}</td><td className="text-danger">{total.r26}</td><td className="fw-bold text-danger">{total.t26}</td>
                            <td className={getVarClass(((total.n27 / total.n26) * 100) - 100)}>{(((total.n27 / total.n26) * 100) - 100).toFixed(2)}%</td>
                            <td className={getVarClass(((total.r27 / total.r26) * 100) - 100)}>{(((total.r27 / total.r26) * 100) - 100).toFixed(2)}%</td>
                            <td className={getVarClass(((total.t27 / total.t26) * 100) - 100)}>{(((total.t27 / total.t26) * 100) - 100).toFixed(2)}%</td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
};
export default Alunos_novos_renovados_serie_rede;